import { useTranslation } from 'react-i18next';
import { FaClipboardList, FaCommentDots, FaIdCard, FaUser } from 'react-icons/fa';

import { useAssignModal, useNavigate, useShowViewResponse } from 'hooks';
import { ConsultationCard, MenuOption } from 'types';

export const useConsultationCardMenuOptions = (
  consultation: ConsultationCard
): MenuOption[] => {
  const { t } = useTranslation('consultation_card');

  const { navigateToSummary, navigateToResponse, navigateToDetails } = useNavigate();
  const { handleAssignConsultation } = useAssignModal();
  const showViewResponse = useShowViewResponse(consultation);

  const options: MenuOption[] = [
    {
      label: t('consultation_summary', 'Consultation summary'),
      onClick: (consultationId) => consultationId && navigateToSummary(consultationId),
      icon: FaClipboardList,
    },
  ];

  if (consultation.isArchived) {
    if (showViewResponse) {
      options.push({
        label: t('view_response', 'View response'),
        onClick: (consultationId) => consultationId && navigateToResponse(consultationId),
        icon: FaCommentDots,
      });
    }
  } else {
    options.push(
      {
        label: t('respond', 'Respond'),
        onClick: (consultationId) => consultationId && navigateToResponse(consultationId),
        icon: FaCommentDots,
      },
      {
        label: t('assign', 'Assign'),
        onClick: (consultationId) =>
          consultationId && handleAssignConsultation(consultationId),
        icon: FaUser,
      }
    );
  }

  options.push({
    label: t('case_details', 'Case details'),
    onClick: (consultationId) => consultationId && navigateToDetails(consultationId),
    icon: FaIdCard,
  });

  return options;
};
